import type { DefaultValues } from "react-hook-form"

import type { ListPricingFormValues, SpecialPricingFormValues } from "./schemas"
import { PricingPath } from "./types"

import { FreightTerms } from "@/graphql/codegen/graphql"
import type { Option } from "@/types/form-fields"

export const PRICING_PATH_OPTIONS: Option<PricingPath>[] = [
  { label: "Send List Price", value: PricingPath.List },
  { label: "Request Special Price", value: PricingPath.Special },
]

interface ProductBadgeDescriptor {
  label: string
  className: string
}

export const PRODUCT_BADGE_BY_PATH: Record<PricingPath, ProductBadgeDescriptor> = {
  [PricingPath.List]: { label: "List Price", className: "bg-tertiary-green-500 text-white" },
  [PricingPath.Special]: { label: "Special Price", className: "bg-tertiary-green-500 text-white" },
}

export const FREIGHT_TERM_OPTIONS: Option<FreightTerms>[] = [
  { label: "Collect", value: FreightTerms.Collect },
  { label: "Prepaid", value: FreightTerms.Prepaid },
  { label: "Prepaid and Add", value: FreightTerms.PrepaidAndAdd },
]

export const DEFAULT_TIER_UOM = "LB"
export const DEFAULT_TIER_UOM_ID = "USSTD_WEIGHT_POUND"

export const MIN_TIER_ROWS = 1
export const MAX_TIER_ROWS = 10

export const EMPTY_STRING_ARRAY: readonly string[] = []

export const DEFAULT_QUOTE_VALIDITY_DAYS = 14

export const toIsoDate = (date: Date): string => date.toISOString().slice(0, 10)

export const DEFAULT_LIST_PRICING_VALUES: ListPricingFormValues = {
  path: PricingPath.List,
  shipFromLocationId: "",
  incoterms: "",
  incotermsLocationId: "",
  estimatedAnnualVolume: null,
  includeLinkedAccounts: false,
}

export const DEFAULT_SPECIAL_PRICING_VALUES: DefaultValues<SpecialPricingFormValues> = {
  path: PricingPath.Special,
  estimatedAnnualVolume: null,
  pricePoint: "",
  incoterms: [],
  incotermsLocationId: "",
  shipFromLocationIds: [],
  freightTerms: undefined,
  includeLinkedAccounts: false,
  effectiveDate: "",
  validUntilDate: null,
  tiers: [{ qty: null, uom: DEFAULT_TIER_UOM, price: "" }],
}

export const buildSpecialPricingDefaults = (): DefaultValues<SpecialPricingFormValues> => {
  const today = new Date()
  const validUntil = new Date(today)
  validUntil.setDate(today.getDate() + DEFAULT_QUOTE_VALIDITY_DAYS)
  return {
    ...DEFAULT_SPECIAL_PRICING_VALUES,
    effectiveDate: toIsoDate(today),
    validUntilDate: toIsoDate(validUntil),
  }
}
